import {deskRename} from './deskRename'
import {partsTypeDirective} from './partsTypeDirective'
import {reactIconsV3} from './reactIconsV3'

export default {
  reactIconsV3,
  partsTypeDirective,
  deskRename,
}
